import axios from 'axios';
import _axios from './index';

export function getCompetitionPreList() {
  return axios.get(`${process.env.VUE_APP_STATIC}/pre-data.text?${Math.random()}`)
}

export function getCompetitionRepList() {
  return axios.get(`${process.env.VUE_APP_STATIC}/rep-data.text?${Math.random()}`)
}

export function getCompetitionInfo() {
  return axios.get(`${process.env.VUE_APP_STATIC}/jingsai-data.json?${Math.random()}`)
}

export function getCompetitionDetail(params) {
  return _axios.get('open/aild/getResult', { params })
}